module.exports = __webpack_public_path__ + "static/media/Kurkan.1e3a52bc.jpg";